const capabilitySetJsonOffLine = {
  分辨率: {
    name: 'resolution',
    single_choice: 1,
    type: 2,
    count: 5,
    list: [
      {
        comment: '466*466(N62、N60)',
        value: 'XMHD01'
      },
      {
        comment: '480*480(L61)',
        value: 'XMHD02'
      },
      {
        comment: '336*480(M67)',
        value: 'XMHD03'
      },
      {
        comment: '390*450(N65)',
        value: 'XMHD04'
      },
      {
        comment: '192*490(N66)',
        value: 'XMHD05'
      }
    ]
  },
  区域: {
    name: 'region',
    type: 2,
    count: 4,
    list: [
      {
        comment: '国内',
        value: 'CN'
      },
      {
        comment: '亚太',
        value: 'AP'
      },
      {
        comment: '印度',
        value: 'IN'
      },
      {
        comment: '海外',
        value: 'GL'
      }
    ]
  },
  打包方式: {
    name: 'packet',
    type: 2,
    count: 4,
    list: [
      {
        comment: '二进制文件',
        value: 'BIN'
      },
      {
        comment: 'assembly打包',
        value: 'ASSEMBLY'
      },
      {
        comment: 'JS微应用框架',
        value: 'MICROJS'
      },
      {
        comment: 'LUA打包',
        value: 'LUA'
      }
    ]
  },
  图片压缩方式: {
    name: 'image_compress',
    type: 3,
    count: 4,
    list: [
      {
        comment: '不压缩',
        value: 0
      },
      {
        title: 'RLEReversed',
        comment: 'RLE标准压缩方式',
        value: 1
      },
      {
        comment: 'RLE-L67特别版',
        value: 2
      },
      {
        comment: 'EZIP- N65AB特别版本',
        value: 3
      }
    ]
  },
  图片格式: {
    name: 'image_fmt',
    type: 3,
    count: 44,
    list: [
      {
        title: 'truecolor_alpha',
        comment: 'ARGB8888',
        value: 0
      },
      {
        title: 'truecolor',
        comment: 'XRGB8888',
        value: 1
      },
      {
        title: 'alpha8',
        comment: 'XRGB8888_ALPHA',
        value: 2
      },
      {
        comment: '16bitRGB565',
        value: 3
      },
      {
        comment: '16bit RGB565_ALPHA',
        value: 4
      },
      {
        comment: 'AXRGB88565',
        value: 5
      },
      {
        comment: 'ARGB8565',
        value: 6
      },
      {
        comment: 'RGB565SWAP_A',
        value: 7
      },
      {
        comment: 'RGB565SWAP',
        value: 8
      },
      {
        comment: 'ALPHA_1BIT',
        value: 9
      },
      {
        comment: 'ALPHA_2BIT',
        value: 10
      },
      {
        comment: 'ALPHA_4BIT',
        value: 11
      },
      {
        comment: 'ALPHA_8BIT',
        value: 12
      },
      {
        comment: 'INDEXED_1BIT',
        value: 13
      },
      {
        comment: 'INDEXED_2BIT',
        value: 14
      },
      {
        comment: 'INDEXED_4BIT',
        value: 15
      },
      {
        title: 'indexed8',
        comment: 'INDEXED_8BIT',
        value: 16
      },
      {
        comment: 'ABGR8888',
        value: 17
      },
      {
        comment: 'RGBA8888',
        value: 18
      },
      {
        comment: 'BGRA8888',
        value: 19
      },
      {
        comment: 'XBGR8888',
        value: 20
      },
      {
        comment: 'RGBX8888',
        value: 21
      },
      {
        comment: 'BGRX8888',
        value: 22
      },
      {
        comment: 'ABGR4444',
        value: 23
      },
      {
        comment: 'ARGB4444',
        value: 24
      },
      {
        comment: 'RGBA4444',
        value: 25
      },
      {
        comment: 'BGRA4444',
        value: 26
      },
      {
        comment: 'ARGB1555',
        value: 27
      },
      {
        comment: 'ABGR1555',
        value: 28
      },
      {
        comment: 'RGBA5551',
        value: 29
      },
      {
        comment: 'BGRA5551',
        value: 30
      },
      {
        comment: 'ABGR2222',
        value: 31
      },
      {
        comment: 'ARGB2222',
        value: 32
      },
      {
        comment: 'RGBA2222',
        value: 33
      },
      {
        comment: 'BGRA2222',
        value: 34
      },
      {
        comment: 'RGBA5658',
        value: 35
      },
      {
        comment: 'BGRA5658',
        value: 36
      },
      {
        comment: 'ABGR8565',
        value: 37
      },
      {
        comment: 'BGR888',
        value: 38
      },
      {
        comment: 'RGB888',
        value: 39
      },
      {
        comment: 'PNG',
        value: 40
      },
      {
        comment: 'JPEG',
        value: 41
      },
      {
        comment: 'GIF',
        value: 42
      },
      {
        comment: 'MP4 ，H264压缩格式',
        value: 43
      }
    ]
  },
  数据源列表: {
    name: 'data_source',
    type: 3,
    count: 193,
    list: [
      {
        group: '时间与日期(time)',
        comment: '时，固件提供数值范围为 [0, 24)',
        value: 0,
        uid: '1108'
      },
      {
        group: '时间与日期(time)',
        comment: '小时个位数',
        value: 1,
        uid: '1109'
      },
      {
        group: '时间与日期(time)',
        comment: '小时十位数',
        value: 2,
        uid: '110A'
      },
      {
        group: '时间与日期(time)',
        comment: '分，固件提供数值范围为 [0, 60)',
        value: 3,
        uid: '1110'
      },
      {
        group: '时间与日期(time)',
        comment: '分钟个位数',
        value: 4,
        uid: '1111'
      },
      {
        group: '时间与日期(time)',
        comment: '分钟十位数',
        value: 5,
        uid: '1112'
      },
      {
        group: '时间与日期(time)',
        comment: '秒，固件提供数值范围为 [0, 60)',
        value: 6,
        uid: '1118'
      },
      {
        group: '时间与日期(time)',
        comment: '秒个位数',
        value: 7,
        uid: '1119'
      },
      {
        group: '时间与日期(time)',
        comment: '秒十位数',
        value: 8,
        uid: '111A'
      },
      {
        group: '时间与日期(time)',
        comment: '分秒，0.01秒，范围0~99，固件提供数值范围为 [0, 100)',
        value: 9,
        uid: '1120'
      },
      {
        group: '时间与日期(time)',
        comment: '分秒的个位数',
        value: 10,
        uid: '1121'
      },
      {
        group: '时间与日期(time)',
        comment: '分秒的十位数',
        value: 11,
        uid: '1122'
      },
      {
        group: '时间与日期(time)',
        comment: '当前时间转换到12小时制后的时，范围[0, 12]',
        value: 12,
        uid: '1128'
      },
      {
        group: '时间与日期(time)',
        comment: '当前时间转换到24小时制后的时，范围[0, 24)',
        value: 13,
        uid: '1130'
      },
      {
        group: '时间与日期(time)',
        comment: '当日时间对于0点的偏移',
        value: 14,
        uid: '1138'
      },
      {
        group: '时间与日期(time)',
        comment: '年，如“2021”',
        value: 15,
        uid: '1208'
      },
      {
        group: '时间与日期(time)',
        comment: '年数值的个位数',
        value: 16,
        uid: '1209'
      },
      {
        group: '时间与日期(time)',
        comment: '年数值的十位数',
        value: 17,
        uid: '120A'
      },
      {
        group: '时间与日期(time)',
        comment: '年数值的百分位',
        value: 18,
        uid: '120B'
      },
      {
        group: '时间与日期(time)',
        comment: '年数值的千分位',
        value: 19,
        uid: '120C'
      },
      {
        group: '时间与日期(time)',
        comment: '月份',
        value: 20,
        uid: '1210'
      },
      {
        group: '时间与日期(time)',
        comment: '月份的个位数',
        value: 21,
        uid: '1211'
      },
      {
        group: '时间与日期(time)',
        comment: '月份的十位数',
        value: 22,
        uid: '1212'
      },
      {
        group: '时间与日期(time)',
        comment: '日期',
        value: 23,
        uid: '1218'
      },
      {
        group: '时间与日期(time)',
        comment: '日期的个位数',
        value: 24,
        uid: '1219'
      },
      {
        group: '时间与日期(time)',
        comment: '日期的十位数',
        value: 25,
        uid: '121A'
      },
      {
        group: '时间与日期(time)',
        comment: '星期，0：周日，1：周一， ... 6:周六',
        value: 26,
        uid: '1220'
      },
      {
        group: '时间与日期(time)',
        comment: '农历年',
        value: 27,
        uid: '1228'
      },
      {
        group: '时间与日期(time)',
        comment: '农历月份',
        value: 28,
        uid: '1230'
      },
      {
        group: '时间与日期(time)',
        comment: '农历日期',
        value: 29,
        uid: '1238'
      },
      {
        group: '时间与日期(time)',
        comment: '天干地支：辛丑...',
        value: 30,
        uid: '1240'
      },
      {
        group: '时间与日期(time)',
        comment: '正月、二月、...、腊月',
        value: 31,
        uid: '1248'
      },
      {
        group: '时间与日期(time)',
        comment: '初一,初二,...,初十,十一,...,二十,廿一,廿二,..,廿九,三十',
        value: 32,
        uid: '1250'
      },
      {
        group: '时间与日期(time)',
        comment: '周一、周二、....、周六、周日',
        value: 33,
        uid: '1258'
      },
      {
        group: '时间与日期(time)',
        comment: '星期一、星期二、……、星期六、星期日',
        value: 34,
        uid: '1259'
      },
      {
        group: '时间与日期(time)',
        comment: 'Monday、Tuesday……、Saturday、Sunday',
        value: 35,
        uid: '125A'
      },
      {
        group: '时间与日期(time)',
        comment: 'MONDAY、TUESDAY、……、SATURDAY、SUNDAY',
        value: 36,
        uid: '125B'
      },
      {
        group: '时间与日期(time)',
        comment: 'monday、tuesday、……、saturday、sunday',
        value: 37,
        uid: '125C'
      },
      {
        group: '时间与日期(time)',
        comment: 'Mon、Tue、……、Sat、Sun',
        value: 38,
        uid: '125D'
      },
      {
        group: '时间与日期(time)',
        comment: 'MON、TUE、……、SAT、SUN',
        value: 39,
        uid: '125E'
      },
      {
        group: '时间与日期(time)',
        comment: 'mon、tue、……、sat、sun',
        value: 40,
        uid: '125F'
      },
      {
        group: '时间与日期(time)',
        comment: '一月、二月、……、十二月',
        value: 41,
        uid: '1260'
      },
      {
        group: '时间与日期(time)',
        comment: 'January、February、……、December',
        value: 42,
        uid: '1261'
      },
      {
        group: '时间与日期(time)',
        comment: 'JANUARY、FEBRUARY、……、DECEMBER',
        value: 43,
        uid: '1262'
      },
      {
        group: '时间与日期(time)',
        comment: 'january、february、……、december',
        value: 44,
        uid: '1263'
      },
      {
        group: '时间与日期(time)',
        comment: 'Jan、Feb、……、Dec',
        value: 45,
        uid: '1264'
      },
      {
        group: '时间与日期(time)',
        comment: 'JAN、FEB、……、DEC',
        value: 46,
        uid: '1265'
      },
      {
        group: '时间与日期(time)',
        comment: 'jan、feb、……、dec',
        value: 47,
        uid: '1266'
      },
      {
        group: '时间与日期(time)',
        comment: '天干地支，范围[0.60)',
        value: 48,
        uid: '1268'
      },
      {
        group: '时间与日期(time)',
        comment: '当前时间是否为上午，1：上午，0：下午',
        value: 49,
        uid: '1308'
      },
      {
        group: '时间与日期(time)',
        comment: '当前时间是否为下午，1：下午，0：上午',
        value: 50,
        uid: '1310'
      },
      {
        group: '时间与日期(time)',
        comment: '当前系统时间是否为24小时制',
        value: 51,
        uid: '1318'
      },
      {
        group: '时间与日期(time)',
        comment:
          '当前时间段，0：凌晨，1:黎明，2:清晨，3:上午，4:中午，5:下午，6:黄昏，7:傍晚，8:晚上\n凌晨： 24点前 - 日出前1小时\n黎明：日出前1小时 - 日出后1小时\n清晨，上午，中午，下午，傍晚：日出后1小时-日落前1小时 时间段均分\n黄昏：日落前1小时 - 日落后1小时\n晚上： 24点前',
        value: 52,
        uid: '1320'
      },
      {
        group: '时间与日期(time)',
        comment: '明天 日期',
        value: 53,
        uid: '1328'
      },
      {
        group: '时间与日期(time)',
        comment: '昨天 日期',
        value: 54,
        uid: '1330'
      },
      {
        group: '时间与日期(time)',
        comment: '后天 日期',
        value: 55,
        uid: '1338'
      },
      {
        group: '时间与日期(time)',
        comment: '前天 日期',
        value: 56,
        uid: '1340'
      },
      {
        group: '时间与日期(time)',
        comment: '明天的星期，星期，0：周日，1：周一， ... 6:周六',
        value: 57,
        uid: '1348'
      },
      {
        group: '时间与日期(time)',
        comment: '前天的星期，星期，0：周日，1：周一， ... 6:周六',
        value: 58,
        uid: '1350'
      },
      {
        group: '时间与日期(time)',
        comment: '双时区 时，固件提供数值范围为 [0, 24)',
        value: 59,
        uid: '1408'
      },
      {
        group: '时间与日期(time)',
        comment: '双时区 小时个位数',
        value: 60,
        uid: '1409'
      },
      {
        group: '时间与日期(time)',
        comment: '双时区 小时十位数',
        value: 61,
        uid: '140A'
      },
      {
        group: '时间与日期(time)',
        comment: '双时区 分，固件提供数值范围为 [0, 60)',
        value: 62,
        uid: '1410'
      },
      {
        group: '时间与日期(time)',
        comment: '双时区 分钟个位数',
        value: 63,
        uid: '1411'
      },
      {
        group: '时间与日期(time)',
        comment: '双时区 分钟十位数',
        value: 64,
        uid: '1412'
      },
      {
        group: '时间与日期(time)',
        comment: '双时区 秒，固件提供数值范围为 [0, 60)',
        value: 65,
        uid: '1418'
      },
      {
        group: '时间与日期(time)',
        comment: '双时区 秒个位数',
        value: 66,
        uid: '1419'
      },
      {
        group: '时间与日期(time)',
        comment: '双时区 秒十位数',
        value: 67,
        uid: '141A'
      },
      {
        group: '时间与日期(time)',
        comment: '双时区 当前时间是否为下午，1：下午，0：上午',
        value: 68,
        uid: '1420'
      },
      {
        group: '时间与日期(time)',
        comment: '双时区 时间转换到12小时制后的时，范围[0, 12]',
        value: 69,
        uid: '1428'
      },
      {
        group: '时间与日期(time)',
        comment: '双时区 时间转换到24小时制后的时，范围[0, 24)',
        value: 70,
        uid: '1430'
      },
      {
        group: '时间与日期(time)',
        comment: '双时区 城市简称',
        value: 71,
        uid: '1438'
      },
      {
        group: '时间与日期(time)',
        comment: '双时区城市列表，格林威治标准时间 GMT ,惠灵顿 WLG...  ',
        value: 72,
        uid: '1440'
      },
      {
        group: '运动健康(health)',
        comment: '步数',
        value: 73,
        uid: '2108'
      },
      {
        group: '运动健康(health)',
        comment: '步数的个位数',
        value: 74,
        uid: '2109'
      },
      {
        group: '运动健康(health)',
        comment: '步数的十位数',
        value: 75,
        uid: '210A'
      },
      {
        group: '运动健康(health)',
        comment: '步数的百位数',
        value: 76,
        uid: '210B'
      },
      {
        group: '运动健康(health)',
        comment: '步数的千位数',
        value: 77,
        uid: '210C'
      },
      {
        group: '运动健康(health)',
        comment: '步数的万分位数',
        value: 78,
        uid: '210D'
      },
      {
        group: '运动健康(health)',
        comment: '步数完成进度，0~100，单位%',
        value: 79,
        uid: '2110'
      },
      {
        group: '运动健康(health)',
        comment: '步数距离，单位kM',
        value: 80,
        uid: '2118'
      },
      {
        group: '运动健康(health)',
        comment: '步数目标值',
        value: 81,
        uid: '2120'
      },
      {
        group: '运动健康(health)',
        comment: '心率，单位bpm',
        value: 82,
        uid: '2208'
      },
      {
        group: '运动健康(health)',
        comment:
          '心率区间，0~6，分别代表：安静、热身、燃脂、有氧、无氧、极限，无效',
        value: 83,
        uid: '2210'
      },
      {
        group: '运动健康(health)',
        comment: '心率最低值，单位bpm',
        value: 84,
        uid: '2218'
      },
      {
        group: '运动健康(health)',
        comment: '心率最高值，单位bmp',
        value: 85,
        uid: '2220'
      },
      {
        group: '运动健康(health)',
        comment: '卡路里',
        value: 86,
        uid: '2308'
      },
      {
        group: '运动健康(health)',
        comment: '卡路里完成进度， 0~100，单位%',
        value: 87,
        uid: '2310'
      },
      {
        group: '运动健康(health)',
        comment: '卡路里目标值',
        value: 88,
        uid: '2318'
      },
      {
        group: '运动健康(health)',
        comment: '站立次数, 0~24',
        value: 89,
        uid: '2408'
      },
      {
        group: '运动健康(health)',
        comment: '站立完成进度，0~100，单位%',
        value: 90,
        uid: '2410'
      },
      {
        group: '运动健康(health)',
        comment: '站立目标值',
        value: 91,
        uid: '2418'
      },
      {
        group: '运动健康(health)',
        comment: '血氧，0～100，单位%',
        value: 92,
        uid: '2508'
      },
      {
        group: '运动健康(health)',
        comment: '压力指数，0~100，',
        value: 93,
        uid: '2608'
      },
      {
        group: '运动健康(health)',
        comment: '血压舒张压，单位mmHg ',
        value: 94,
        uid: '2708'
      },
      {
        group: '运动健康(health)',
        comment: '血压收缩压，单位mmHg ',
        value: 95,
        uid: '2710'
      },
      {
        group: '运动健康(health)',
        comment: '血压舒张压，单位kPa，如“20.5”',
        value: 96,
        uid: '2718'
      },
      {
        group: '运动健康(health)',
        comment: '血压收缩压，单位kPa，如“20.5”',
        value: 97,
        uid: '2720'
      },
      {
        group: '运动健康(health)',
        comment: '血压单位，0：mmHg 1：kPa',
        value: 98,
        uid: '2728'
      },
      {
        group: '运动健康(health)',
        comment: '睡眠时长，单位为小时，如“10.2"',
        value: 99,
        uid: '2808'
      },
      {
        group: '运动健康(health)',
        comment: '睡眠得分，0~100',
        value: 100,
        uid: '2810'
      },
      {
        group: '运动健康(health)',
        comment: '睡眠目标完成度， 0~100',
        value: 101,
        uid: '2818'
      },
      {
        group: '运动健康(health)',
        comment: '睡眠质量，0~3，4， 分别代表：差、一般、较好、很好、未知',
        value: 102,
        uid: '2820'
      },
      {
        group: '运动健康(health)',
        comment: '睡眠目标,单位为小时，如“8.2"',
        value: 103,
        uid: '2828'
      },
      {
        group: '运动健康(health)',
        comment: '中高强度锻炼时长，单位分钟，0~999分钟',
        value: 104,
        uid: '2908'
      },
      {
        group: '运动健康(health)',
        comment: '中高强度锻炼完成度',
        value: 105,
        uid: '2910'
      },
      {
        group: '运动健康(health)',
        comment: '中高强度目标值',
        value: 106,
        uid: '2918'
      },
      {
        group: '运动健康(health)',
        comment: '能量消耗， 0~100，单位%',
        value: 107,
        uid: '2A08'
      },
      {
        group: '运动健康(health)',
        comment: '恢复时间，0~96，单位小时',
        value: 108,
        uid: '2B08'
      },
      {
        group: '运动健康(health)',
        comment: '跑力指数，10~80',
        value: 109,
        uid: '2B10'
      },
      {
        group: '运动健康(health)',
        comment: '今日元气值，0~80',
        value: 110,
        uid: '2B18'
      },
      {
        group: '运动健康(health)',
        comment: '近7日累积元气值，0~560',
        value: 111,
        uid: '2B20'
      },
      {
        group: '运动健康(health)',
        comment: '血糖值 0～25.0 单位mmol/L',
        value: 112,
        uid: '2C08'
      },
      {
        group: '运动健康(health)',
        comment: '血糖更新时间，字符串',
        value: 113,
        uid: '2C10'
      },
      {
        group: '天气(weather)',
        comment: '温度单位，0：摄氏度，1：华氏度',
        value: 114,
        uid: '3108'
      },
      {
        group: '天气(weather)',
        comment: '当前体感温度，单位摄氏度',
        value: 115,
        uid: '3118'
      },
      {
        group: '天气(weather)',
        comment: '当前温度，单位摄氏度',
        value: 116,
        uid: '3120'
      },
      {
        group: '天气(weather)',
        comment: '当前湿度，单位%',
        value: 117,
        uid: '3128'
      },
      {
        group: '天气(weather)',
        comment:
          '详见天气代码tab页，未知（必选）、晴（必选）、多云（必选）、阴（必选）、阵雨、雷阵雨、冰雹、雨夹雪、雨（必选）、小雨、中雨、大雨、暴雨、雪（必选）、阵雪、小雪、中雪、大雪、暴雪、雾（必选）、浮尘、扬沙、沙尘暴、霾（必选）',
        value: 118,
        uid: '3130'
      },
      {
        group: '天气(weather)',
        comment: '当前风向角，0~359°，360表示无持续风向，361表示旋转风',
        value: 119,
        uid: '3138'
      },
      {
        group: '天气(weather)',
        comment: '当前风速，单位km/h',
        value: 120,
        uid: '3140'
      },
      {
        group: '天气(weather)',
        comment:
          '当前风力级别， 0~12分别代表：微风, 1级, 2级, 3级, 4级, 5级, 6级, 7级, 8级, 9级, 10级, 11级, 12级及以上, ',
        value: 121,
        uid: '3148'
      },
      {
        group: '天气(weather)',
        comment: '当前AQI，范围0~500',
        value: 122,
        uid: '3150'
      },
      {
        group: '天气(weather)',
        comment:
          '当前空气质量指数等级， 0~5分别代表： 优, 良, 轻度污染, 中度污染, 重度污染, 严重污染',
        value: 123,
        uid: '3158'
      },
      {
        group: '天气(weather)',
        comment: '当前降雨概率， 0~100',
        value: 124,
        uid: '3160'
      },
      {
        group: '天气(weather)',
        comment: '当地海平面气压，单位hPa，百帕',
        value: 125,
        uid: '3168'
      },
      {
        group: '天气(weather)',
        comment: '当前能见度，单位m? kM?',
        value: 126,
        uid: '3170'
      },
      {
        group: '天气(weather)',
        comment: '当前紫外线指数，如SPF15',
        value: 127,
        uid: '3178'
      },
      {
        group: '天气(weather)',
        comment:
          '穿衣指数，0~7分别代表:适宜短袖、适宜衬衫、适宜薄外套、适宜夹克、适宜风衣、适宜棉衣、适宜冬大衣、适宜羽绒服',
        value: 128,
        uid: '3180'
      },
      {
        group: '天气(weather)',
        comment:
          'TBD 个位数和十位数分别代表限行的尾数，如数值38代表限行尾数为3和8，数值超过99代表没有限行',
        value: 129,
        uid: '3188'
      },
      {
        group: '天气(weather)',
        comment: '天气预警字符串',
        value: 130,
        uid: '3190'
      },
      {
        group: '天气(weather)',
        comment: '预警级别',
        value: 131,
        uid: '3198'
      },
      {
        group: '天气(weather)',
        comment: '更新时间',
        value: 132,
        uid: '31A0'
      },
      {
        group: '天气(weather)',
        comment:
          '当前风向，0~9分别代表：无持续风向, 旋转风, 北风, 东北风, 东风, 东南风, 南风, 西南风, 西风, 西北风',
        value: 133,
        uid: '31A8'
      },
      {
        group: '天气(weather)',
        comment: '日出时间的小时部分',
        value: 134,
        uid: '31B0'
      },
      {
        group: '天气(weather)',
        comment: '日出时间的分钟部分',
        value: 135,
        uid: '31B8'
      },
      {
        group: '天气(weather)',
        comment: '日落时间的小时部分',
        value: 136,
        uid: '31C0'
      },
      {
        group: '天气(weather)',
        comment: '日落时间的分钟部分',
        value: 137,
        uid: '31C8'
      },
      {
        group: '天气(weather)',
        comment: '当前温度，单位华氏度',
        value: 138,
        uid: '31D0'
      },
      {
        group: '天气(weather)',
        comment: '日出时，固件提供数值范围为[0,24)',
        value: 139,
        uid: '31D8'
      },
      {
        group: '天气(weather)',
        comment: '日落时, 固件提供数值范围为[0,24)',
        value: 140,
        uid: '31E0'
      },
      {
        group: '天气(weather)',
        comment: '今天日出时间？',
        value: 141,
        uid: '3208'
      },
      {
        group: '天气(weather)',
        comment: '今天日落时间？',
        value: 142,
        uid: '3210'
      },
      {
        group: '天气(weather)',
        comment: '今天最高温度，单位摄氏度',
        value: 143,
        uid: '3218'
      },
      {
        group: '天气(weather)',
        comment: '今天最低温度，单位摄氏度',
        value: 144,
        uid: '3220'
      },
      {
        group: '天气(weather)',
        comment: '今天天气from',
        value: 145,
        uid: '3228'
      },
      {
        group: '天气(weather)',
        comment: '今天天气to',
        value: 146,
        uid: '3230'
      },
      {
        group: '天气(weather)',
        comment: '今天风向from',
        value: 147,
        uid: '3238'
      },
      {
        group: '天气(weather)',
        comment: '今天风向to',
        value: 148,
        uid: '3240'
      },
      {
        group: '天气(weather)',
        comment: '今天风速from',
        value: 149,
        uid: '3248'
      },
      {
        group: '天气(weather)',
        comment: '今天风速to',
        value: 150,
        uid: '3250'
      },
      {
        group: '天气(weather)',
        comment: '今天空气质量指数：11',
        value: 151,
        uid: '3258'
      },
      {
        group: '天气(weather)',
        comment: '今天降水概率：12',
        value: 152,
        uid: '3260'
      },
      {
        group: '天气(weather)',
        comment: '今天最高温度，单位华氏度',
        value: 153,
        uid: '3268'
      },
      {
        group: '天气(weather)',
        comment: '今天最低温度，单位华氏度',
        value: 154,
        uid: '3270'
      },
      {
        group: '天气(weather)',
        comment: 'TBD 明天日出时间？',
        value: 155,
        uid: '3308'
      },
      {
        group: '天气(weather)',
        comment: 'TBD 明天日落时间？',
        value: 156,
        uid: '3310'
      },
      {
        group: '天气(weather)',
        comment: '明天最高温度，单位摄氏度',
        value: 157,
        uid: '3318'
      },
      {
        group: '天气(weather)',
        comment: '明天最低温度，单位摄氏度',
        value: 158,
        uid: '3320'
      },
      {
        group: '天气(weather)',
        comment: '明天天气from',
        value: 159,
        uid: '3328'
      },
      {
        group: '天气(weather)',
        comment: '明天天气to',
        value: 160,
        uid: '3330'
      },
      {
        group: '天气(weather)',
        comment: '明天风向from',
        value: 161,
        uid: '3338'
      },
      {
        group: '天气(weather)',
        comment: '明天风向to',
        value: 162,
        uid: '3340'
      },
      {
        group: '天气(weather)',
        comment: '明天风速from',
        value: 163,
        uid: '3348'
      },
      {
        group: '天气(weather)',
        comment: '明天风速to',
        value: 164,
        uid: '3350'
      },
      {
        group: '天气(weather)',
        comment: '明天空气质量指数：11',
        value: 165,
        uid: '3358'
      },
      {
        group: '天气(weather)',
        comment: '明天降水概率：12',
        value: 166,
        uid: '3360'
      },
      {
        group: '天气(weather)',
        comment: '明天最高温度，单位华氏度',
        value: 167,
        uid: '3368'
      },
      {
        group: '天气(weather)',
        comment: '明天最低温度，单位华氏度',
        value: 168,
        uid: '3370'
      },
      {
        group: '系统数据(system)',
        comment: '电量百分比',
        value: 169,
        uid: '4108'
      },
      {
        group: '系统数据(system)',
        comment: '当前充电状态，0：没有充电，1：正在充电，2：TBD，3：TBD',
        value: 170,
        uid: '4110'
      },
      {
        group: '系统数据(system)',
        comment: '勿扰状态， 0：未开启， 1：已开启',
        value: 171,
        uid: '4118'
      },
      {
        group: '系统数据(system)',
        comment: '蓝牙状态，0：未连接，1：已连接',
        value: 172,
        uid: '4120'
      },
      {
        group: '系统数据(system)',
        comment: 'WIFI状态，0：未连接，1：已连接',
        value: 173,
        uid: '4128'
      },
      {
        group: '系统数据(system)',
        comment: '屏幕LOCK，0：屏幕已解锁，1：屏幕已锁定',
        value: 174,
        uid: '4130'
      },
      {
        group: '系统数据(system)',
        comment: '音量',
        value: 175,
        uid: '4138'
      },
      {
        group: '系统数据(system)',
        comment: '海拔高度，单位m, 范围-700~12000',
        value: 176,
        uid: '4208'
      },
      {
        group: '系统数据(system)',
        comment: '噪声音量',
        value: 177,
        uid: '4210'
      },
      {
        group: '系统数据(system)',
        comment: '噪音级别',
        value: 178,
        uid: '4218'
      },
      {
        group: '系统数据(system)',
        comment: '加速度计x',
        value: 179,
        uid: '4220'
      },
      {
        group: '系统数据(system)',
        comment: '加速度计y',
        value: 180,
        uid: '4228'
      },
      {
        group: '系统数据(system)',
        comment: '加速度计z',
        value: 181,
        uid: '4230'
      },
      {
        group: '系统数据(system)',
        comment: '陀螺仪x',
        value: 182,
        uid: '4238'
      },
      {
        group: '系统数据(system)',
        comment: '陀螺仪y',
        value: 183,
        uid: '4240'
      },
      {
        group: '系统数据(system)',
        comment: '陀螺仪z',
        value: 184,
        uid: '4248'
      },
      {
        group: '应用数据(app)',
        comment: '最近的闹钟时间的小时部分',
        value: 185,
        uid: '5108'
      },
      {
        group: '应用数据(app)',
        comment: '最近的闹钟时间的分钟部分',
        value: 186,
        uid: '5110'
      },
      {
        group: '系统数据(system)',
        comment: '指南针角度，[0，360）',
        value: 187,
        uid: '4250'
      },
      {
        group: '系统数据(system)',
        comment: '气压，单位hPa, 范围200·1200',
        value: 188,
        uid: '4258'
      },
      {
        group: '应用数据(app)',
        comment: '禁飞时间 时间部分',
        value: 189,
        uid: '5208'
      },
      {
        group: '应用数据(app)',
        comment: '禁飞时间 单位部分，[0，3]',
        value: 190,
        uid: '5210'
      },
      {
        group: '应用数据(app)',
        comment: '水面间隔时间 时间部分，',
        value: 191,
        uid: '5218'
      },
      {
        group: '应用数据(app)',
        comment: '水面间隔时间 单位部分，[0，3]',
        value: 192,
        uid: '5220'
      }
    ]
  },
  表盘协议版本号: {
    name: 'protocol',
    type: 1,
    count: 4,
    list: [
      {
        comment: '1.8.0',
        value: '1.8.0'
      },
      {
        comment: '1.8.15',
        value: '1.8.15'
      },
      {
        comment: '1.8.16',
        value: '1.8.16'
      },
      {
        comment: '1.8.17',
        value: '1.8.17'
      }
    ]
  }
};

export type CapabilityJson = typeof capabilitySetJsonOffLine;

export const getCapabilitySetJson = async () => {
  // 默认值为离线数据
  let capabilitySetJson: CapabilityJson = capabilitySetJsonOffLine;
  const ifOnline = navigator.onLine;
  // 查询
  if (ifOnline) {
    const url =
      'https://cdn.cnbj1.fds.api.mi-img.com/hlth-operate/appres/images/caps-editor/ability.json';
    try {
      capabilitySetJson = await window
        .fetch(url, { cache: 'no-store' })
        .then((response) => {
          return response.json();
        });
    } catch (error) {
      capabilitySetJson = capabilitySetJsonOffLine;
    }
  }
  return capabilitySetJson;
};
